/**
 * Escapes the specified special characters in the search text.
 * Currently, only the following characters are escaped: \, ^, and ].
 * Note: Additional characters might need to be escaped in the future,
 * depending on the requirements from product team to properly detect advanced vs. simple searches.
 */
export function escapeLuceneSpecialCharacters(searchText: string): string {
    if (!searchText) {
        return searchText;
    }

    const specialChars = ["\\", "^", "]"];

    const regex = new RegExp(`[${specialChars.join("\\")}]`, "g");
    return searchText.replace(regex, "\\$&");
}

export function getTemplateEnvironment(envWithId: string): string | null {
    return envWithId?.includes(":") ? envWithId.split(":")[0] : null;
}

export function getTemplateId(envWithId: string): string {
    return envWithId?.includes(":") ? envWithId.split(":")[1] : envWithId;
}
